import { render, staticRenderFns } from "./InquiryForm.vue?vue&type=template&id=52e3d9b0&"
import script from "./InquiryForm.vue?vue&type=script&lang=ts&"
export * from "./InquiryForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports